import { render, staticRenderFns } from "./config-info.vue?vue&type=template&id=6a7b7240&"
import script from "./config-info.vue?vue&type=script&lang=js&"
export * from "./config-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "config-info.vue"
export default component.exports